import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from "@angular/forms";
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogConfig as MatDialogConfig} from "@angular/material/legacy-dialog";
import * as _ from "lodash";
import { first } from "rxjs/operators";
import { Subscription } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";

import { AppGlobals } from "../../../app.globals";
import { OrientationService, AlertService, MediaWatcherService } from "../../../_services";
import { UnSavedChangesDialogComponent } from "../../../_components/unSavedChangesDialog/unSavedChangesDialog.component";

@Component({
    templateUrl: "orientationCheckListItemVideoDialog.component.html",
    styleUrls: ["orientationCheckListItemVideoDialog.component.css"]
})
export class OrientationCheckListItemVideoDialogComponent implements OnInit, OnDestroy {
    videoFormGroup: UntypedFormGroup;
    isMobile = false;
    mediaWatcherSubscription: Subscription;
    checkListItem = null;
    orientationSemesterStudentId: number;
    fileUrl = null;
    youTubeUrl = null;
    videoQuestions = null;
    isPastDeadline = false;
    studentAge = null;
    cannotBeModified = false;

    constructor(private dialogRef: MatDialogRef<OrientationCheckListItemVideoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: any,
        private formBuilder: UntypedFormBuilder,
        public dialog: MatDialog,
        private appGlobals: AppGlobals,
        private alertService: AlertService,
        private orientationService: OrientationService,
        private mediaWatcherService: MediaWatcherService,
        private sanitizer: DomSanitizer) {
        this.checkListItem = data.checkListItem;
        this.orientationSemesterStudentId = data.orientationSemesterStudentId;
        this.isPastDeadline = data.isPastDeadline;
        this.studentAge = data.studentAge
    }

    ngOnDestroy() {
        this.mediaWatcherSubscription.unsubscribe();

        URL.revokeObjectURL(this.fileUrl);
    }

    ngOnInit() {
        this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
            this.isMobile = isMobile;
        });

        this.initializeForm();
        this.onChanges();

        this.orientationService.getOrientationCheckListItemVideo(this.checkListItem.orientationCheckListItemId)
            .pipe(first())
            .subscribe((result: any) => {
                if (result) {
                    this.cannotBeModified = (this.isPastDeadline && !this.checkListItem.canBeModifiedAfterDeadline) || this.checkListItem.orientationSemesterStudentCheckListItemStatusId === 3 || this.checkListItem.orientationSemesterStudentCheckListItemStatusId === 8;

                    if (this.checkListItem.orientationCheckListItemUrl) {
                        if (!this.cannotBeModified)
                            this.youTubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${this.checkListItem.orientationCheckListItemUrl}?controls=0`);
                        else
                            this.youTubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://img.youtube.com/vi/${this.checkListItem.orientationCheckListItemUrl}/maxresdefault.jpg`);
                    } else {
                        const blob = b64toBlob(result.attachmentFile.fileStream, result.attachmentFile.fileExtension);

                        this.fileUrl = URL.createObjectURL(blob);
                    }

                    this.videoQuestions = _.orderBy(result.orientationCheckListItemQuestions, ["isMandatory", "sortOrder"], ["desc", "asc"]) as any;

                    for (let i = 0; i < this.videoQuestions.length; i++) {

                        _.forEach(this.videoQuestions[i].orientationCheckListItemQuestionAnswers, a => {
                            a.questionId = this.videoQuestions[i].id;
                            a.isAnsweredCorrectly = false;

                            this.videoFormGroup.addControl(`answer${a.id}`, new UntypedFormControl({ value: this.cannotBeModified ? a.isCorrect : a.isAnsweredCorrectly, disabled: this.cannotBeModified }, { validators: /*this.videoQuestions[i].isMandatory && a.isCorrect ? Validators.requiredTrue :*/ null }));
                        });

                        this.videoQuestions[i].notAnswered = !this.cannotBeModified;
                        this.videoQuestions[i].allAnswersCorrect = this.cannotBeModified;

                        this.videoQuestions[i].orientationCheckListItemQuestionAnswers = _.orderBy(this.videoQuestions[i].orientationCheckListItemQuestionAnswers, "sortOrder");
                    }
                }
            });
    }

    initializeForm() {
        this.videoFormGroup = this.formBuilder.group({

        });
    }

    onChanges() {

    }

    get videoFormControls() { return this.videoFormGroup.controls as any; }

    saveDocumentDetails(submitBtn: HTMLButtonElement) {
        _.forEach(this.videoQuestions, f => {
            f.allAnswersCorrect = !f.orientationCheckListItemQuestionAnswers.find(a => (!a.isAnsweredCorrectly && a.isCorrect) || (!a.isAnsweredCorrectly && a.isAnswered));
            f.notAnswered = !f.orientationCheckListItemQuestionAnswers.find(a => a.isAnswered);
        });

        //if (!this.videoFormGroup.invalid && this.customValidation()) {
        //    this.alertService.showMessage("All Questions Answered Correctly.", "Orientation CheckList Items", this.appGlobals.alertMessageTypes.success);
        //}else
        //    return;

        if (this.videoFormGroup.invalid || !this.customValidation()) {
            return;
        }

        if (this.videoFormGroup.dirty) {
             setTimeout(() => {
                submitBtn.disabled = true;
            }, 0);

            const saveModel = {
                id: this.checkListItem.id,
                orientationSemesterStudentId: this.orientationSemesterStudentId,
                orientationCheckListItemTypeId: this.checkListItem.orientationCheckListItemTypeId,
                orientationSemesterCheckListItemId: this.checkListItem.orientationSemesterCheckListItemId,
                orientationSemesterStudentCheckListItemStatusId: 8,
                studentAge: this.studentAge,
                isAttachmentViewed: false,
                rowversion: this.checkListItem.rowversion
            };

            this.orientationService.markNonDocumentOrientationSemesterStudentCheckListItemAsCompleted(saveModel)
                .pipe(first())
                .subscribe(() => {
                    this.alertService.showMessage("All Questions Answered Correctly.", "Orientation CheckList Items", this.appGlobals.alertMessageTypes.success);

                    this.dialogRef.close(true);
                });
        }
    }

    customValidation() {
        if (this.videoQuestions.find(question => (question.isMandatory && !question.allAnswersCorrect) || (!question.isMandatory && !question.notAnswered && !question.allAnswersCorrect))) {
            for (let i = 0; i < this.videoQuestions.length; i++) {

                _.forEach(this.videoQuestions[i].orientationCheckListItemQuestionAnswers, a => {
                    a.isAnsweredCorrectly = false;
                    a.isAnswered = false;

                    this.videoFormGroup.controls[`answer${a.id}`].setValue(false);
                });

                this.videoQuestions[i].notAnswered = true;
                this.videoQuestions[i].allAnswersCorrect = false;

                this.videoQuestions[i].orientationCheckListItemQuestionAnswers = _.orderBy(this.videoQuestions[i].orientationCheckListItemQuestionAnswers, "sortOrder");
            }

            this.alertService.showMessage("Some Questions are not Answered Correctly.", "Orientation CheckList Items", this.appGlobals.alertMessageTypes.error);

            return false;
        }

        return true;
    }

    markQuestionCompleted(event: any, answer: any) {
        answer.isAnsweredCorrectly = event.checked && answer.isCorrect;
        answer.isAnswered = event.checked;

        //const question = this.videoQuestions.find(f => f.id === answer.questionId);

        ////if (question.isMandatory) {
        //question.allAnswersCorrect = !question.orientationCheckListItemQuestionAnswers.find(a => (!a.isAnsweredCorrectly && a.isCorrect) || (!a.isAnsweredCorrectly && a.isAnswered));
        //question.notAnswered = !question.orientationCheckListItemQuestionAnswers.find(a => a.isAnswered);
        //}
    }

    close(refresh) {
        if (this.videoFormGroup.dirty) {
            //show unsaved changes dialog
            const dialogConfig = new MatDialogConfig();

            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.closeOnNavigation = true;
            dialogConfig.width = this.isMobile ? "60vw" : "30vw";
            dialogConfig.height = "auto";
            dialogConfig.panelClass = "unSavedChanges-dialog-container";

            const dialogRef = this.dialog.open(UnSavedChangesDialogComponent, dialogConfig);

            dialogRef.afterClosed().subscribe(result => {
                if (result === "confirm") {
                    this.dialogRef.close(refresh);
                }
            });
        } else {
            this.dialogRef.close(refresh);
        }
    }
}

const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}
